const getCartURL = () => {
  const cartURL = document.documentElement.lang === 'es' ? '/es/cart' : '/cart';

  return cartURL;
};

function buildCartItems(queryInfo) {
  const basketItems = {
    items: queryInfo.variant_id.map((variant, index) => {
      if (queryInfo.frequency[index]) {
        return {
          quantity: queryInfo.quantity[index],
          id: queryInfo.variant_id[index],
          selling_plan: queryInfo.sellingPlan.id,
          'properties[refer_google_sc]': (queryInfo.promoValue === 'google_tag') ? 1 : 0,
        };
      }

      return {
        quantity: queryInfo.quantity[index],
        id: queryInfo.variant_id[index],
        properties: (queryInfo.properties && queryInfo.properties[index])
          ? JSON.parse(queryInfo.properties[index]) : {},
      };
    }),
  };

  return basketItems;
}

// eslint-disable-next-line no-unused-vars
async function addProductsToCart() {
  const queryData = window.location.search;
  const urlData = new URLSearchParams(queryData);
  const productHandle = urlData.getAll('handle');
  const response = await fetch(`/products/${productHandle}.js`);

  if (response.ok) {
    const productDetails = await response.json();
    const queryInfo = {
      variant_id: urlData.getAll('default_id[]'),
      quantity: urlData.getAll('quantity[]'),
      frequency: urlData.getAll('frequency'),
      locale: urlData.getAll('locale'),
      properties: urlData.getAll('properties[]'),
      promoValue: urlData.getAll('lineitem'),
    };

    queryInfo.sellingPlan = productDetails.selling_plan_groups[0].selling_plans.find(({
      name,
    }) => name.includes(queryInfo.frequency));

    if (queryInfo.variant_id && queryInfo.quantity) {
      const formData = buildCartItems(queryInfo);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })
        .then(() => {
          let cartRedirect = '';

          if (queryInfo.locale[0] === 'es') {
            cartRedirect = '/es/cart';
          } else {
            cartRedirect = '/cart';
          }

          window.location.href = cartRedirect;
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }
  }
}

// eslint-disable-next-line no-unused-vars
function addToCart(cartData, locale) {
  const itemsToAdd = cartData;
  const postData = {
    items: itemsToAdd,
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(postData),
  }).then(() => {
    window.location = getCartURL();
  });
}

// eslint-disable-next-line no-unused-vars
function quickOrdertoCart(variantId, quantity) {
  const data = {
    quantity,
    id: variantId,
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  }).then((response) => {
    if (response.status >= 400 && response.status < 600) {
      throw new Error('Bad response from server');
    }

    return response.json();
  }).then(() => {
    window.location = getCartURL();
  }).catch((error) => {
    console.error('Error:', error);
  });
}

// eslint-disable-next-line no-unused-vars
function orderAllToCart(variants) {
  const itemsToAdd = variants.map((variant) => {
    const [id, quantity] = variant.split(':');

    if (id === '') return undefined;

    return {
      quantity,
      id,
    };
  }).filter((item) => typeof item !== 'undefined');

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      items: itemsToAdd,
    }),
    dataType: 'json',
  }).then((response) => {
    if (response.status >= 400 && response.status < 600) {
      throw new Error('Bad response from server');
    }

    return response.json();
  }).then(() => {
    window.location = getCartURL();
  }).catch((error) => {
    console.error('Error:', error);
  });
}
